import { CardRadioButton, MLPVersion, useTranslation } from '@nextgen-web-framework/all';
import { OrderType, getMarketOrderType } from '@commerce-cart-webcomponents/sdk';
import { CartTypes } from '../types/propsType';
import styles from './CartTypeSelection.module.scss';
import { CartTypeSelectionProps } from './types/propsType';

export const CartTypeSelection = ({ onRadioChange, cardClassName }: CartTypeSelectionProps) => {
  const t = useTranslation();
  const { isGCOEnabledForMarket, isProxyOrderEnabledForMarket } = getMarketOrderType();
  const selfCartText = t('cart.cartTypeSelectionDrawer.selfCart');
  const downLineText = t('cart.cartTypeSelectionDrawer.downLine');
  const multipleText = t('cart.cartTypeSelectionDrawer.multiple');
  const subTextDownline = t('cart.cartTypeSelectionDrawer.subTextDownline');
  const subTextGCO = t('cart.cartTypeSelectionDrawer.subTextGroupCart');

  const cartTypes: CartTypes[] = [
    {
      text: selfCartText,
      iconName: 'user',
      value: OrderType.Regular,
      subText: null,
    },
    {
      text: downLineText,
      iconName: 'user-plus',
      value: OrderType.Proxy,
      subText: <span className={styles['cart-type-selection-subText']}>{subTextDownline}</span>,
    },
    {
      text: multipleText,
      iconName: 'user-group',
      value: OrderType.Gco,
      subText: <span className={styles['cart-type-selection-subText']}>{subTextGCO}</span>,
    },
  ];

  const filterOrderOptionsBasedOnMarketConfig = (orderType: string) => {
    switch (orderType) {
      case OrderType.Proxy:
        return isProxyOrderEnabledForMarket;
      case OrderType.Gco:
        return isGCOEnabledForMarket;
      default:
        return true;
    }
  };

  return (
    <div className={styles['cart-type-selection-wrapper']}>
      <div className={styles['cart-type-selection-wrapper-radio-buttons']}>
        {cartTypes
          .filter(({ value }) => filterOrderOptionsBasedOnMarketConfig(value))
          .map(({ iconName, text, value, subText }) => (
            //const checked = initalOrderType === value;

            <CardRadioButton
              className={cardClassName}
              //theme={checked ? (Theme.PURPLE as RadioButtonTheme) : Theme.BLACK}
              key={iconName}
              divider={true}
              //checked={checked}
              onChange={() => onRadioChange?.(value)}
              mlpVersion={MLPVersion.ONE}
              label={text}
              icon={{
                iconName,
              }}
            >
              {subText}
            </CardRadioButton>
          ))}
      </div>
    </div>
  );
};
